<div class="address-chooser">
    <div class="header-container">
        <h2>Address Search Results</h2>
        <button class="mat-button icon-button close" aria-label="close dialog" [mat-dialog-close]="">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <mat-card>
        <mat-card-content>
            <div *ngIf="!isLoading; else loadingTemp">
                <p>
                    <span *ngIf="addresses.length > 0; else noAddressesFound">
                        The search returned the following address(es). If no suitable address(es) were returned, input a different
                        address</span
                    ><span *ngIf="!appliedLocationData">
                        or <a class="search-link" (click)="applySearch($event)">search again</a> using only city or ZIP/postal code</span
                    >.
                </p>
                <div
                    class="addressOption"
                    *ngFor="let addr of addresses"
                    (click)="selectAddress(addr)"
                    [ngClass]="{ selectedAddressWrapper: isSelectedAddress(addr.id) }"
                >
                    <mat-checkbox [checked]="isSelectedAddress(addr.id)" color="primary" class="checkbox checkbox-with-wrap white-checkbox">
                        {{ addr.formattedAddress }}
                    </mat-checkbox>
                </div>
            </div>
            <mat-card-actions class="formActionButtonGroup clearfix">
                <button *ngIf="!appliedLocationData" mat-stroked-button (click)="applySearch($event)" class="search-again-btn">
                    Search Again
                </button>
                <button
                    mat-raised-button
                    color="primary"
                    [mat-dialog-close]="selectedAddress"
                    class="new-primary-button done-btn"
                    [ngClass]="{ 'no-margin': appliedLocationData }"
                >
                    Done
                </button>
            </mat-card-actions>
        </mat-card-content>
    </mat-card>
</div>

<ng-template #loadingTemp>
    <clare-spinner text="Fetching address..."></clare-spinner>
</ng-template>

<ng-template #noAddressesFound>
    <span>No addresses found. Please try a different address</span>
</ng-template>
